import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { getUbicacion, createUbicacion, updateUbicacionById, deleteUbicacionById, getTipoUbicacion } from "../api";

const FilterTableUbicacion = () => {
  const [Ubicacion, setUbicacion] = useState([]);
  const [filteredUbicacion, setFilteredUbicacion] = useState([]);
  const [formData, setFormData] = useState({ id: 0, descripcion: "" });
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState("");
  const [filterText, setFilterText] = useState("");
  const [tipoUbicacion, setTipoUbicacion] = useState([]);

  const fetchDropdownData = async () => {
    try {
      const [tipoUbicacionResponse] = await Promise.all([
        getTipoUbicacion()
      ]);
      setTipoUbicacion(tipoUbicacionResponse.data);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };

  const fetchUbicacion = async () => {
    try {
      const response = await getUbicacion();
      setUbicacion(response.data);
      setFilteredUbicacion(response.data); // Initially show all items
    } catch (error) {
      console.error("Error fetching  ubicacion:", error);
      setError("Error loading data");
    }
  };

  useEffect(() => {
    fetchUbicacion();
    fetchDropdownData();
  }, []);

  useEffect(() => {
    if (filterText) {
      const filtered = Ubicacion.filter((Ubicacion) =>
        Ubicacion.descripcion.toLowerCase().includes(filterText.toLowerCase())
      );
      setFilteredUbicacion(filtered);
    } else {
      setFilteredUbicacion(Ubicacion);
    }
  }, [filterText, Ubicacion]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditing) {
        await updateUbicacionById(formData.id, { descripcion: formData.descripcion });
        alert(" de Ubicacion actualizado con éxito.");
      } else {
        await createUbicacion(formData);
        alert(" de Ubicacion registrado con éxito.");
      }
      setFormData({ id: 0, descripcion: "" });
      setIsEditing(false);
      fetchUbicacion();
    } catch (error) {
      console.error("Error procesando el  de ubicacion:", error);
    }
  };

  const handleEdit = (Ubicacion) => {
    setFormData(Ubicacion);
    setIsEditing(true);
  };

  const handleClearFilters = () => {
    setIsEditing(false);
    setFormData({ id: 0, descripcion: "" });
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Estás seguro de eliminar este  de ubicacion?")) {
      try {
        await deleteUbicacionById(id);
        alert(" de Ubicacion eliminado con éxito.");
        fetchUbicacion();
      } catch (error) {
        console.error("Error eliminando el  de ubicacion:", error);
      }
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <center><h2>{isEditing ? "Editar Ubicacion" : "Agregar Ubicacion"}</h2></center>
        <div className="input-group">
          <input
            type="text"
            name="id"
            value={formData.id}
            onChange={handleChange}
            className="input"
            disabled={isEditing}
            hidden
          />
        </div>
        <div className="input-group">
          <label className="label3">Descripción</label>
          <input
            type="text"
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            className="input-form-2"
          />
        </div>

        <label className="label2">Tipo Ubicacion</label>
          <select
            name="id_tipo_ubicacion"
            value={formData.id_tipo_ubicacion}
            onChange={handleChange}
            className="input-form-1"
          >
            {tipoUbicacion.map((tipoUbicacion) => (
              <option key={tipoUbicacion.id_tipo_ubicacion} value={tipoUbicacion.id}>
                {tipoUbicacion.descripcion}
              </option>
            ))}
          </select>

          <label className="label2">Contenedor</label>
          <select
            name="id_ubicacion_contenedor"
            value={formData.id_ubicacion_contenedor}
            onChange={handleChange}
            className="input-form-1"
          >
            {Ubicacion.map((Ubicacion) => (
              <option key={Ubicacion.id_ubicacion} value={Ubicacion.id}>
                {Ubicacion.descripcion}
              </option>
            ))}
          </select>

        <center>
          <button type="submit" className="button-form-blue">
          {isEditing ? "Actualizar" : "Registrar"}
          </button>
          <button  type="reset" className="button-form-gray" onClick={handleClearFilters}>
              Cancelar
          </button>
        </center>
      </form>
      <hr />
      <div className="input-group">
        <input
          type="text"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          placeholder="Buscar por descripción..."
          className="input2"
        />
      </div>
      {filteredUbicacion.length === 0 ? (
        <p>{error || "Cargando datos..."}</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Descripción</th>
              <th>Tipo Ubicacion</th>
              <th>Contenedor</th>
              <th colSpan="2"><center>Acciones</center></th>
            </tr>
          </thead>
          <tbody>
            {filteredUbicacion.map((Ubicacion) => (
              <tr key={Ubicacion.id}>
                <td>{Ubicacion.id}</td>
                <td>{Ubicacion.descripcion}</td>
                <td>{Ubicacion.tipo_ubicacion}</td>
                <td>{Ubicacion.ubicacion_contenedor}</td>
                <td>
                  <button onClick={() => handleEdit(Ubicacion)} className="button-table-blue">
                    Editar
                  </button>
                </td><td>
                  <button onClick={() => handleDelete(Ubicacion.id)} className="button-table-red">
                    Borrar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

FilterTableUbicacion.propTypes = {
  ubicacion: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      descripcion: PropTypes.string,
    })
  ),
};

export default FilterTableUbicacion;
